import { queryOptions } from "@tanstack/react-query"

import { apiKey } from "@/lib/api/changes"
import { apiFetch } from "@/lib/api/client"
import type { ApiResource } from "@/lib/api/types"
import type { FcaRegisterFirm } from "@/types/fca-register"

export const fcaRegisterQueries = {
  /** Everything the FCA Register says about the firm, worded by the API. */
  forFirm: (firmId: string) =>
    queryOptions({
      queryKey: apiKey(`/firms/${firmId}/fca-register`),
      queryFn: async ({ signal }) => {
        const { data } = await apiFetch<ApiResource<FcaRegisterFirm>>(
          `/firms/${firmId}/fca-register`,
          { signal }
        )

        return data
      },
    }),
}
